import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HistoryDownloadJob, HistoryDownloadService } from '../../services/history-download.service';

/** Floating bottom-right tray showing yearly-history downloads; mounted in AppComponent. */
@Component({
  selector: 'app-history-download-tray',
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
  templateUrl: './history-download-tray.component.html',
  styleUrl: './history-download-tray.component.css',
})
export class HistoryDownloadTrayComponent {
  readonly downloads = inject(HistoryDownloadService);

  get runningCount(): number {
    return this.downloads.jobs().filter(j => j.status === 'running').length;
  }

  progress(job: HistoryDownloadJob): number {
    if (job.status !== 'running') return 100;
    // Leave the last slice for building the file
    return Math.round((job.done / (job.total + 1)) * 100);
  }

  skippedLabel(job: HistoryDownloadJob): string {
    return job.skipped.map(y => y ?? 'latest').join(', ');
  }

  trackById = (_: number, job: HistoryDownloadJob) => job.id;
}
